<template>
  <footer
    class="footer"
    v-if="!isAdminView"
    id="HolyFooter"
  >
    <b-container>
      <b-row>
        <b-col md="6">{{ offerDate }}</b-col>
        <b-col
          md="6"
          class="text-right"
        >
          GFU Cyrus AG | <a
            href="https://www.gfu.net/impressum.html"
            data-gtm-imprint
          >{{ $t('legal.imprint') }}</a> | <a
            href="https://www.gfu.net/datenschutz.html"
            data-gtm-agb
          >{{ $t('legal.privacy') }}</a>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>

import { mapGetters } from 'vuex';
import { formatDate } from '../../misc/LocaleFormat';

export default {
  data() {
    return {
      isAdminView: false,
    };
  },
  computed: {
    ...mapGetters(['offer']),
    offerDate: {
      get() {
        return this.offer ? formatDate(this.offer.createdAt, this.offer.language || 'de') : ''
      }
    },
  },
  mounted: function () {
    this.isAdminView = this.$router.currentRoute.fullPath.split('/')
      .some(path => (path === 'admin'));
  },
  watch: {
    $route(to, from) {
      this.isAdminView = this.$router.currentRoute.fullPath.split('/')
        .some(path => (path === 'admin'));
    }
  }
}

</script>

<style>
.footer a {
  color: white;
}

.footer {
  position: absolute;
  width: 100%;
}

.footer a {
  text-decoration: none;
}
</style>
